import { Injectable } from '@angular/core';
import { HttpHeaders} from '@angular/common/http';

@Injectable({providedIn: 'root'})
export class BaseService {


        jwt() {
            let token = localStorage.getItem('auth_token');
            let headers: HttpHeaders = new HttpHeaders();
            headers = headers.append('Content-Type', 'application/json');
            headers = headers.append('Authorization', 'Bearer ' + token);
            return headers;
        }

}